import React, {useCallback} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {Link} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import ModalBaseLayout from '../ModalBaseLayout';
import {ActionModalHide} from '../../../store/actions/actions-modal';
import {ActionRouteNavigate} from '../../../store/actions/actions-route';
import {ROUTES} from '../../../configs/routes';
import {addPassedVideoPoll} from '../../../api/video-poll.api';
import {NotificationError} from '../../../services/notifications';
import {getUserNameFromString} from '../../../services/common';
import defaultUserImage from '../../../assets/images/required/user.png';

const ModalVideoPollRecordSaving = (props) => {
  const settings = ModalBaseLayout.getInitialSettings({
    className: 'modal-center',
    closeButton: true,
    keyboard: true,
  });

  const {videoPoll, user, loggedIn} = props;

  const savedPollData = {
    user: user._id,
    videoPoll: videoPoll._id,
    record: props.recUrl,
    pollData: {
      description: videoPoll.description,
      vacancy: videoPoll.vacancy,
      company: videoPoll.company,
      firstQuestionDelay: videoPoll.firstQuestionDelay,
      delayBetweenQuestions: videoPoll.delayBetweenQuestions,
      questions: videoPoll.questions,
      questionsCount: videoPoll.questionsCount,
      totalTime: videoPoll.totalTime,
    },
  };

  const sendSaveRequest = useCallback(async (data) => {
    await addPassedVideoPoll(data).then((res) => {
      props.ActionModalHide();
      props.ActionRouteNavigate(ROUTES.MY_VIDEO_POLL.route);
    }).catch((error) => {
      NotificationError(error.error_description || error.message);
    });
  }, []);

  const onSaveClick = useCallback(() => {
    void sendSaveRequest(savedPollData);
  }, []);

  const onSaveAndSentClick = useCallback(() => {
    void sendSaveRequest({...savedPollData, sendBackToEmployer: true});
  }, []);

  const name = getUserNameFromString(videoPoll.createdBy.name, true);

  if (!loggedIn) {
    return (
      <ModalBaseLayout {...settings}>
        <div className="modal-inner">
          <div className="modal-container">
            <div className="modal-content">
              <h3>Отправка видеоопроса</h3>
              <p className="text-dark text-sm margin-b-10">Вы успешно записали видеоопрос.</p>
              <p className="text-dark text-sm margin-b-10">
                Заполните поля для возможности отправки видеоопроса работодателю (все поля обязательны для заполнения).
              </p>
              <div className="form-wrap">
                <input type="text" className="ui-input margin-b-10" placeholder="Ваше имя" required="" />
                <input type="text" className="ui-input margin-b-10" placeholder="Ваша фамилия" required="" />
                <input type="text" className="ui-input margin-b-10" placeholder="Ваше отчество" required="" />
                <input type="email" className="ui-input margin-b-10" placeholder="Ваш email" required="" />
                <input type="tel" className="ui-input margin-b-10" placeholder="Ваш телефон" required="" />
              </div>
              <p className="text-dark text-sm margin-b-10">Видеозапись обрабатывается.</p>
              <p className="text-dark text-sm margin-b-10">
                Не дожидаясь полной обработки, Вы можете назначить задачу системе - отправка обработанной записи
                видеоопроса инициатору:
              </p>
              <div className="send-panel-inner">
                <div className="row align-centr">
                  <div className="col-sm-3">
                    <span className="text-sm text-dark margin-r-10">Пользователю:</span>
                  </div>
                  <div className="col-sm-9 text-dark flex align-centr">
                    <div className="image-wrap">
                      <div className="user-image">
                        <img src={videoPoll.createdBy.photoUrl || defaultUserImage} alt={name} />
                      </div>
                    </div>
                    <b>{name}</b>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-6">
                  <div className="btn btn-conture btn-block margin-r-10">Отложить</div>
                </div>
                <div className="col-sm-6">
                  <div className="btn btn-base btn-block">Отправить после обработки</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ModalBaseLayout>
    );
  }

  return (
    <ModalBaseLayout {...settings}>
      <div className="modal-inner">
        <div className="modal-container">
          <div className="modal-content">
            <h3>Обработка, сохранение и отправка видеоопроса</h3>
            <p className="text-dark text-sm margin-b-10">Вы успешно записали видеоопрос.</p>
            <p className="text-dark text-sm margin-b-10">Видеозапись обрабатывается.</p>
            <p className="text-dark text-sm margin-b-10">
              После обработки она будет автоматически сохранена на Вашей странице&nbsp;
              <Link to={ROUTES.MY_VIDEO_POLL.route} className="link">&laquo;Мои видеоопросы&raquo;</Link>
            </p>
            <p className="text-dark text-sm margin-b-10">
              Не дожидаясь полного сохранения, Вы можете назначить задачу системе - отправка обработанной записи
              видеоопроса инициатору:
            </p>
            <div className="send-panel-inner">
              <div className="row align-centr">
                <div className="col-sm-3">
                  <span className="text-sm text-dark margin-r-10">Пользователю:</span>
                </div>
                <div className="col-sm-9 text-dark flex align-centr">
                  <div className="image-wrap">
                    <div className="user-image">
                      <img src={videoPoll.createdBy.photoUrl || defaultUserImage} alt={name} />
                    </div>
                  </div>
                  <b>{name}</b>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <button className="btn btn-conture btn-block margin-r-10" onClick={onSaveClick}>Сохранить</button>
              </div>
              <div className="col-sm-6">
                <button className="btn btn-base btn-block" onClick={onSaveAndSentClick}>Сохранить и отправить</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ModalBaseLayout>
  );
};

ModalVideoPollRecordSaving.defaultProps = {
  videoPoll: {},
};
ModalVideoPollRecordSaving.propTypes = {
  videoPoll: PropTypes.shape({}),
};

function mapStateToProps({rUser, rSession}) {
  return {
    user: rUser,
    loggedIn: rSession.LOGGED_IN,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    ActionModalHide,
    ActionRouteNavigate,
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalVideoPollRecordSaving);
